import { Title, TitleProps } from "dash-styled"

type StaticAccordionProps = {
    title: string
    children: React.ReactNode
    className?: string
    titleComponent?: TitleProps["component"]
    bodyClassName?: string
    withFooter?: boolean
}

export const StaticAccordion = ({
    title,
    children,
    className = "",
    titleComponent = "h4",
    bodyClassName = "bg-smoke-20 p-6 shadow-inner",
    withFooter = false
}: StaticAccordionProps) => {
    return (
        <div className={`mb-4 border border-solid rounded-large ${className}`}>
            <div className="flex items-center bg-white p-2 pl-6 rounded-t-large border-b border-b-smoke-320 min-h-13">
                <Title
                    component={titleComponent}
                    variant="heading4"
                    className="capitalize w-full m-0"
                >
                    {title}
                </Title>
            </div>
            <div className={bodyClassName}>{children}</div>
            {withFooter && (
                <div className="h-6 bg-white border-t border-t-smoke-320 rounded-b-large"></div>
            )}
        </div>
    )
}
